module.exports = __webpack_public_path__ + "img/workout-old2.fe1b7fb8.png";